<template>
    <div :class="'d-flex flex-column m-0 p-0 align-items-center bg-white px-2 py-2 w-100 '">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:"EmptyContainer",        
}
</script>
